import { Component , OnDestroy , OnInit} from '@angular/core';
import { NomiDescrittoriSezione } from 'src/app/common/configuration/nomi-descrittori-sezione';
import { PdaParty, PdaPartyModel } from 'src/app/pda/models/sections/party';
import { SectionsServiceTsService } from 'src/app/pda/utils/Service/sections.service.ts.service';
import { PartyServiceTsService } from './Service/party.service.ts.service';
import { pdaConfiguration } from 'src/app/pda/utils/pda-configuration';
import { Subscription } from 'rxjs';
import { PdaDataStore } from 'src/app/pda/store/pda-store';
import { PdaAccessToken, PdaAuthService } from 'src/app/pda/utils/Service/pda-auth.service';
import { mockPartyValue } from 'src/app/pda/utils/mock/party-mock-value';
import { PdaPartyAccordionType, pdaPartyAccordionTypesCass, pdaPartyAccordionTypesDefault, pdaPartyAccordionTypesSiecic } from './models/party-accordion-types';
import { pdaRegistryConst } from 'src/app/pda/pages/consultazione/constants/registry-const';

@Component({
  selector: 'app-pda-section-party',
  templateUrl: './pda-section-party.component.html',
  styleUrls: ['./pda-section-party.component.css']
})
export class PdaSectionPartyComponent implements OnDestroy,OnInit{

  collapseState: { [key: string]: boolean } = {};
  previousCollapseState: { [key: string]: boolean } = {};
  isSelectMode: boolean = false;
  selectMsg: string = "Seleziona dati da importare";
  selectedParties: PdaParty[] = [];
  partyTypes: PdaPartyAccordionType[] = [];

  tlfSub: Subscription;
  pctSub: Subscription;

  idFascicoloTlf : string;
  config = pdaConfiguration;
  model : PdaPartyModel;

  constructor(private sectionService: SectionsServiceTsService, private partiService: PartyServiceTsService, private pdaAuthService: PdaAuthService){
    // this.mockData = mockPartyValue();
    this.partyTypes.forEach(type => {
      this.collapseState[type.filterName] = false;
      this.previousCollapseState[type.filterName] = false;
    });

  }

  ngOnDestroy(): void {
    if(this.tlfSub) this.tlfSub.unsubscribe();
    if(this.pctSub) this.pctSub.unsubscribe();
  }
  ngOnInit(): void {
    this.getIdFascicoloTlf();
    this.getData();
    // this.model = mockPartyValue();
  }

  setModel(data: any){
    this.model = { parti: data.parti, dataUltimoAggiornamento: data.dataUltimoAggiornamento };
    PdaDataStore.getInstance().modelParty = this.model;
    this.loadAccordions();
  }

  loadAccordions(){
    if(!!PdaDataStore.getInstance().pctInfoFascicolo){
      let registry = pdaRegistryConst.find(reg => reg.value == PdaDataStore.getInstance().pctInfoFascicolo.registro);
      let registryType = !!registry ? registry.type : "";
      switch(registryType){
        case "SIECIC":
          this.setPartyTypes(pdaPartyAccordionTypesSiecic);
          break;
        case 'CASSCI':
        case 'CASSPE':
          this.setPartyTypes(pdaPartyAccordionTypesCass);
          if(!!this.model.parti) this.model.parti.sort((a,b) => this.orderPartiCassazione(a,b));
          break;
        default:
          this.setPartyTypes(pdaPartyAccordionTypesDefault);
          break;
      }
    }
  }

  setPartyTypes(partyTypes: PdaPartyAccordionType[]){
    this.partyTypes = partyTypes;
    this.partyTypes.forEach(type => {
      this.collapseState[type.filterName] = false;
      this.previousCollapseState[type.filterName] = false;
    });
  }

  orderPartiCassazione(a: PdaParty, b: PdaParty): number {
    let nominativoA = (a.nome + " " + a.cognome + "( " + a.codiceFiscale + " )").toLocaleLowerCase();
    let nominativoB = (b.nome + " " + b.cognome + "( " + b.codiceFiscale + " )").toLocaleLowerCase();
    let localeCompare = nominativoA.localeCompare(nominativoB);
    if(localeCompare == 0){
      let nominativoLegaleA = (a.legale + "( " + a.cfLegale + " )").toLocaleLowerCase();
      let nominativoLegaleB = (b.legale + "( " + b.cfLegale + " )").toLocaleLowerCase();
      return nominativoLegaleA.localeCompare(nominativoLegaleB);
    }
    else return localeCompare;
  }


  getIdFascicoloTlf () {
    let index = this.config.findIndex(x => x.context === NomiDescrittoriSezione.SEZIONE_CONTROPARTI_FASCICOLO);
    this.idFascicoloTlf = this.config[index].properties.idFascicolo;
  }

  async updatePct() {
    let token: PdaAccessToken = await this.pdaAuthService.getPdaToken();
    this.sectionService.updatePCT(token, this.idFascicoloTlf, "parti").subscribe(
      data => {
        this.setModel(data);
      }
    )
  }

  getData(){
    if(!PdaDataStore.isSameId(this.idFascicoloTlf)){
      PdaDataStore.cleanupStore();
      PdaDataStore.getInstance().idFascicoloTlf = this.idFascicoloTlf;
    }
    if(!!PdaDataStore.getInstance().modelParty) {
      this.setModel(PdaDataStore.getInstance().modelParty);
      return
    }

    this.tlfSub = this.sectionService.getIdFascicoloPCT(this.idFascicoloTlf).subscribe({
      next: (idPct) =>{
        if(idPct.length > 0) {
          let pct = idPct[0];
          this.fetchPctFascicoloInfo(pct);
          this.pctSub =  this.partiService.getControparti(pct.idFascicoloPct).subscribe((data)=>{
            this.setModel(data);
          })
        }
      },error: () =>{}
    })
  }

  private fetchPctFascicoloInfo(data: any) {
    if(PdaDataStore.getInstance().pctInfoFascicolo == null) {
      this.sectionService.getInfoFascicoloPct(data.idFascicoloPct).subscribe(
        fascicoloPctInfo => {
          PdaDataStore.getInstance().pctInfoFascicolo = fascicoloPctInfo;
          this.loadAccordions();
        }
      );
    }
  }


  changeSelectMode() {
    if (this.model.parti.length > 0) {
      this.isSelectMode = !this.isSelectMode;

      if (this.isSelectMode) {
        this.selectMsg = "Importa dati";
        this.selectedParties = [];
        this.partyTypes.forEach(type => {
          this.previousCollapseState[type.filterName] = this.collapseState[type.filterName];
          this.collapseState[type.filterName] = true;
        });
      } else {
        this.selectMsg = "Seleziona dati da importare";
        this.onImport();
        this.partyTypes.forEach(type => {
          this.collapseState[type.filterName] = this.previousCollapseState[type.filterName];
        });
      }
    }
  }


  async onImport() {
    //TODO
    let token: PdaAccessToken = await this.pdaAuthService.getPdaToken();
    let idFascicoloPct = this.selectedParties[0].idFascicoloPct;
    let partiesRequest: string[] = [];

    if(this.selectedParties.length != 0){
      this.selectedParties.forEach((s) =>
        partiesRequest.push(s.idPartePct)
      );

      this.partiService.importParti(token, this.idFascicoloTlf, idFascicoloPct, partiesRequest).subscribe(
        data => {
          this.partiService.onNextImportParti();
          this.setModel(data);
        }
      );
    }
  }

  getPartiesOfType(partyType: string): PdaParty[]{

    return this.model.parti.filter(s => s.tipoParte == partyType);

  }

  isPartyTypeSelected(partyType: string){

    let partiesOfType = this.getPartiesOfType(partyType);
    return partiesOfType.length > 0 && !partiesOfType.some(p => !this.isPartySelected(p));
  }

  onClickPartyTypeSelected(partyType: string){

    //Three cases: act and all documents are selected, only some documents are selected, no documents are selected
    //All selected: remove all
    //Some selected: remove some, add all
    //None selected: add all
    if(this.isPartyTypeSelected(partyType)){
      this.onSelectedPartyTypeRemove(partyType);
    }
    else if(this.selectedParties.some(s => s.tipoParte == partyType)){
      this.onSelectedPartyTypeRemove(partyType);
      this.onSelectedPartyTypeAdd(partyType);
    }
    else{
      this.onSelectedPartyTypeAdd(partyType);
    }

  }

  onSelectedPartyTypeAdd(partyType: string){

    this.getPartiesOfType(partyType).forEach(p => this.onSelectedAdd(p));

  }

  onSelectedPartyTypeRemove(partyType: string){
    this.getPartiesOfType(partyType).forEach(p => this.onSelectedRemove(p))
  }

  isPartySelected(party: PdaParty){

    return this.selectedParties.some(s => s == party);

  }

  onClickSelected(party: PdaParty){

    if(this.isPartySelected(party)) this.onSelectedRemove(party);
    else this.onSelectedAdd(party);

  }

  onSelectedAdd(party: PdaParty){

    this.selectedParties.push(party);

  }

  onSelectedRemove(party: PdaParty){
    this.selectedParties = this.selectedParties.filter(s => s != party);
  }

  accordionToggleClassHandler(partyType: string) {
    return this.collapseState[partyType] ? "accordion-toggle" : "accordion-toggle collapsed";


  }

  accordionBodyClassHandler(partyType: string) {
    return this.collapseState[partyType] ? "panel-collapse collapse in" : "panel-collapse collapse";


  }

  toggleCollapse(partyType: string) {
    this.collapseState[partyType] = !this.collapseState[partyType];
  }


  hasPartiesOfType(partyType: string){
    return this.model.parti.some(s => s.tipoParte == partyType);
  }

  isControparte(partyType: PdaPartyAccordionType){
    return partyType.type == 'controparte';
  }


}
